// 画面遷移とトーストの最小ヘルパー

const SCREENS = ['home', 'camera', 'loading', 'result', 'history', 'candidates', 'museums', 'nearby', 'search', 'translate', 'chat', 'mode', 'glossary', 'compare', 'exhibitions', 'preparation'];

let toastTimer = null;

export function showScreen(name) {
  if (!SCREENS.includes(name)) {
    throw new Error(`unknown screen: ${name}`);
  }
  for (const s of SCREENS) {
    const el = document.getElementById(`screen-${s}`);
    if (el) el.classList.toggle('screen--active', s === name);
  }
  // グローバルプレイヤーの表示制御（result画面のときのみ）
  const player = document.getElementById('result-player');
  if (player) player.hidden = name !== 'result';
  window.scrollTo(0, 0);
}

export function setLoadingMessage(message) {
  const el = document.getElementById('loading-message');
  if (el) el.textContent = message;
}

export function showToast(message, durationMs = 2400) {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = message;
  el.hidden = false;
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    el.hidden = true;
    toastTimer = null;
  }, durationMs);
}

export function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = String(str ?? '');
  return div.innerHTML;
}

export function formatTime(seconds) {
  const total = Math.max(0, Math.floor(seconds));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
